import { TLandingSettings } from 'types/landing';

import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { SiteState } from '../types';

type UpdateSettingPayload = {
    name: string;
    value: boolean;
};

const initialState: SiteState = {
    settings: {
        landing_page_gallery_block: false,
        landing_page_promo_block: false,
        landing_page_products_block: false,
        landing_page_services_block: false,
        landing_page_vacancies_block: false,
        landing_page_contancts_block: false,
        landing_page_crm_desc_block: false,
    },
};

const siteSlice = createSlice({
    name: 'site',
    initialState,
    reducers: {
        updateSettings(state, action: PayloadAction<TLandingSettings>) {
            state.settings = action.payload;
        },
        updateSetting(state, action: PayloadAction<UpdateSettingPayload>) {
            const { name, value } = action.payload;
            state.settings[name] = value;
        },
    },
});

export const { updateSettings, updateSetting } = siteSlice.actions;
export default siteSlice.reducer;
